import React from 'react';
import PropTypes from 'prop-types';
import HomeCardBig from './HomeCardBig';
import HomeCardSmall from './HomeCardSmall';
import Preloader from './Preloader';

const Home = (props) => {  
    const { isLoading, news } = props;
    let topNews = {};
    const mainNews = [];

    news.forEach((item) => {
        const tags = item.privateTags.map(tag => tag._id);
        if (typeof topNews.title === 'undefined' && tags.indexOf('olimpic2018-main-material-top') + 1 > 0) {
            topNews = item;
        } else {
            mainNews.push(item);
        }
    });

    return (
        <section className="home">{
            !isLoading ? 
                <React.Fragment>
                    <HomeCardBig data={topNews} />
                    <HomeCardSmall
                        data={mainNews.length > 4 ? mainNews.splice(0, 4) : mainNews}
                    />
                </React.Fragment> : <Preloader />} 
        </section>
    );
};

Home.propTypes = {
    isLoading: PropTypes.bool,
    news: PropTypes.arrayOf(PropTypes.object)
};

Home.defaultProps = { 
    isLoading: false,
    news: null
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.jsx